// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2EXE_","file":"styles_file__2tzeh"};